import Select from 'react-select'
import { SelectWrapper } from '../wrapper'
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useGetCompanySizesQuery } from '@/store/services'

export const CompanySizeSelector = ({ onChange, value, required = false }) => {
  const { t } = useTranslation()

  const { data: companySizes = [], isLoading: isLoadingCompanySizes } = useGetCompanySizesQuery()
  const companySizeOptions = useMemo(() => {
    return [
      ...companySizes.map(([label, value]) => ({ value, label }))
    ]
  }, [companySizes, t])

  const selectedOption = value
    ? companySizeOptions.find(option => option.value === value)
    : null

  const handleChange = (selectedOption) => {
    if (selectedOption === null) {
      // Cuando se presiona 'X', selectedOption será null
      onChange({ value: '' }); // Enviamos un string vacío en lugar de null
    } else {
      onChange({ value: selectedOption.value });
    }
  }

  return (
    <SelectWrapper label={t('size.one')} required={required}>
      {(styles) => (
        <Select
          placeholder={t('select.one')}
          isLoading={isLoadingCompanySizes}
          options={companySizeOptions}
          loadingMessage={() => t('select.loading')}
          value={selectedOption}
          styles={styles}
          menuPortalTarget={document.body}
          isClearable={true}
          onChange={handleChange}
        />
      )}
    </SelectWrapper>
  )
}

CompanySizeSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}
